module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-1.34a3501c.svg";